import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../themes';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const useStyles = makeStyles((theme) => ({
  whitePaper: {
    color: Colors.black,
    background: Colors.white,
  },
  languageTitle: {
    paddingLeft: 20,
    color: Colors.blackText,
    marginBottom: 6,
  },
  button: {
    fontSize: 14,
    color: Colors.black,
    border: `1px solid ${Colors.disabledGrey}`,
    '&:hover': {
      background: Colors.disabledGrey,
      color: Colors.white,
    },
  },
  redButton: {
    color: Colors.red,
    border: `1px solid ${Colors.red}`,
    '&:hover': {
      background: Colors.red,
    },
  },
  blueButton: {
    color: Colors.white,
    background: Colors.blue,
    border: 'none',
    '&:hover': {
      background: Colors.lightBlue,
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AlertDialogSlide = (props) => {
  const {
    open,
    handleClose,
    title,
    contentText,
    cancelButtonText,
    confirmButtonText,
    onConfirm,
    isOKOnly,
    itemsList,
  } = props;
  const classes = useStyles();

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.whitePaper} id="alert-dialog-slide-title" variant="h2" component="h3">
          {title}
        </DialogTitle>
        <DialogContent className={classes.whitePaper}>
          <DialogContentText className={classes.whitePaper} id="alert-dialog-slide-description">
            {contentText}
          </DialogContentText>
          {itemsList && <ul>{itemsList}</ul>}
        </DialogContent>
        <DialogActions className={classes.whitePaper}>
          {!isOKOnly && (
            <Button
              onClick={props.leftButtonAction ? props.leftButtonAction : handleClose}
              color="primary"
              className={clsx([classes.button, props.leftButtonRed && classes.redButton])}
            >
              {cancelButtonText}
            </Button>
          )}
          {onConfirm && (
            <Button
              onClick={onConfirm}
              color="primary"
              className={clsx([classes.button, classes.redButton, props.rightButtonBlue && classes.blueButton])}
            >
              {isOKOnly ? 'OK' : confirmButtonText}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertDialogSlide;
